import * as React from "react";
import {FreeTextField} from "../../../../../../Components/Form/FreeTextField";
import {FieldWrapper} from "./FieldWrapper";

interface IOrderIdFieldProps {
    value: string;
    onChange(value: string): void;
    onDelete(): void;
}

export const OrderIdField = ({value, onChange, onDelete}: IOrderIdFieldProps) => (
    <FieldWrapper onDelete={onDelete}>
        <FreeTextField label="Order ID" value={value} onChange={onChange}/>
    </FieldWrapper>
);
